export default __webpack_public_path__ + "fef171315512ddd39d1743089db9883f.png";